import { useForm } from 'react-hook-form';

import { PreparePayrunCreate } from '@xemplo/gp-types';
import { useModalDialog } from '@xemplo/modal-dialog';
import { usePreparePayrun } from '@xemplo/payrun-query';
import { ToastType, useToast } from '@xemplo/toast';

import { PayrunPrepareFormFields, PayrunPrepareProps } from './payrun-prepare.types';

export const usePayunPrepare = (props: Readonly<PayrunPrepareProps>) => {
  const { payrunId, onSuccessCallback } = props;
  const { addToast } = useToast();

  const { dialogProps, closeDialog, openModalDialog, isOpen } = useModalDialog({
    id: 'payrun-prepare-modal',
  });
  const DEFAULT_ERROR_MESSAGE = 'An unexpected error occurred. Please try again later.';

  const { mutateAsync } = usePreparePayrun({
    onSuccess: () => {
      handleSuccess();
    },
    onError: (error) => {
      const errorMessage = error?.response?.data?.validationErrors?.errors[0].message;
      addToast({
        text: errorMessage ?? DEFAULT_ERROR_MESSAGE,
        type: ToastType.Alert,
      });
    },
    payrunId: payrunId,
  });

  const methods = useForm<PayrunPrepareFormFields>();

  const handleSuccess = () => {
    addToast({
      text: `Payrun prepared`,
      type: ToastType.Confirmation,
    });
    methods.reset();
    closeDialog();
    onSuccessCallback?.();
  };

  const handleSubmit = methods.handleSubmit(async (data: PayrunPrepareFormFields) => {
    const payload: PreparePayrunCreate = { notes: data.notes };
    await mutateAsync(payload);
  });

  return {
    methods,
    isOpen,
    dialogProps,
    openModalDialog,
    closeDialog,
    handleSubmit,
  };
};
